import { render, staticRenderFns } from "./collapseInfo.vue?vue&type=template&id=0fc036ab&scoped=true"
import script from "./collapseInfo.vue?vue&type=script&lang=js"
export * from "./collapseInfo.vue?vue&type=script&lang=js"
import style0 from "./collapseInfo.vue?vue&type=style&index=0&id=0fc036ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc036ab",
  null
  
)

export default component.exports